import { Component, OnInit, Input } from '@angular/core';
import { UserService } from '../../../../services';
import { Tip, Stylist, Sale } from '../../../../models'
import { ModalController } from '@ionic/angular';
import { MaskitoOptions, MaskitoElementPredicateAsync } from '@maskito/core';
import { maskitoNumberOptionsGenerator } from '@maskito/kit';
import { Utilities } from '../../../../utilities/utilities';

export interface StylistTip {
  stylist: Stylist;
  amount: number;
}

@Component({
  selector: 'smr-split-tip',
  templateUrl: './split-tip.component.html',
  styleUrls: ['./split-tip.component.scss'],
})

export class SplitTipComponent implements OnInit {
  currency: string;
  currencyMask: MaskitoOptions;

  readonly maskPredicate: MaskitoElementPredicateAsync = async (el) =>
    (el as HTMLIonInputElement).getInputElement();

  @Input() sale: Sale;
  @Input() amountDetails;
  stylistTips: Array<StylistTip> = [];

  stylist: Stylist;

  completed: boolean = false;

  tipRemaining: number;

  constructor(
    private userService: UserService,
    private modalCtrl: ModalController
  ) {

  }

  ngOnInit() {

    let firstLineItem = this.sale.lineitems.first();
    if(firstLineItem){
      this.stylist = firstLineItem.stylist
    }
    this.currency = Utilities.decodeHTML(
      this.userService.getSalon().getCurrency()
    );

    this.currencyMask = maskitoNumberOptionsGenerator({
      decimalZeroPadding: true,
      precision: 2,
      decimalSeparator: '.',
      thousandSeparator: ',',
      min: 0,
      max: this.amountDetails.tip.amount/100,
      prefix: this.currency,
    });
    this.stylistTips.push({stylist: this.stylist ? this.stylist : this.userService.getUser(), amount: this.amountDetails.tip.amount/100});
    this.tipRemaining = 0;
  }

  onStylistSelectChange(event, index) {
    this.stylistTips[index].stylist = event
  }

  addMember() {
    this.stylistTips.push({stylist: undefined, amount: 0});
  }

  removeMember(index) {
    this.stylistTips.splice(index, 1);
  }


  check() {
  }

  editAmount() {
    this.tipRemaining = this.amountDetails.tip.amount/100;
    this.stylistTips.forEach(stylisttip => {
      stylisttip.amount.toString().substring(1)
      this.tipRemaining -= Number(stylisttip.amount.toString().substring(1))
    })

    this.tipRemaining = Math.round(this.tipRemaining*100)/100

    if(this.tipRemaining === 0) {
      this.completed = true;
    } else {
      this.completed = false;
    }
  }

  save() {
    this.stylistTips.forEach(stylisttip => {

      const tip: Tip = new Tip({
        id: undefined,
        stylistID: stylisttip ? stylisttip.stylist.getID() : undefined,
        stylist: stylisttip.stylist,
        value: Number(stylisttip.amount.toString().substring(1)),
        isRefunded: 0,
      });
      this.sale = this.sale.addTip(tip)
    })

    this.modalCtrl.dismiss(this.sale);
  }
}
